const KEY = 'pending-anytime-ticket-purchase';

export function savePendingAnytimeTicketPurchase() {
	localStorage.setItem(KEY, 'true');
}

export function getPendingAnytimeTicketPurchase(): boolean {
	return localStorage.getItem(KEY) === 'true';
}

export function clearPendingAnytimeTicketPurchase() {
	localStorage.removeItem(KEY);
}
